/**
 * Users guide — multi-tenancy with user_id for end-user data isolation.
 */

import { createFileRoute } from "@tanstack/react-router";
import { DocsPage } from "@/components/docs/docs-page";
import { usersContent } from "@/constants/docs/users";

export const Route = createFileRoute("/docs/users")({
	component: UsersPage,
});

function UsersPage() {
	return <DocsPage title="Users" content={usersContent} />;
}
